export default function CaseStudyHero() {
  return (
    <>
      {/* Logo Banner with Sport Images */}
      <section className="relative bg-gradient-to-r from-teal-500 via-teal-600 to-pink-500 pt-4 pb-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            {/* TeamPro Logo */}
            <div className="flex items-center justify-center space-x-3 mb-6">
              <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center shadow-xl">
                <i className="ri-trophy-line text-4xl text-teal-500"></i>
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold text-white">
                TeamPro
              </h1>
            </div>
            
            <p className="text-xl text-white/90 font-medium mb-8">
              Complete Equipment Management for Every Sport
            </p>
          </div>

          {/* Sport Images Grid */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
            {/* Football */}
            <div className="relative group cursor-pointer">
              <div className="relative w-full h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/960457bccd29c68b471a3b2ebda98dab.jpg"
                  alt="Football Equipment"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-bold text-lg">Football</h3>
                  <p className="text-white/80 text-sm">Helmets, Pads & More</p>
                </div>
              </div>
            </div>

            {/* Basketball */}
            <div className="relative group cursor-pointer">
              <div className="relative w-full h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20basketball%20shoes%20sneakers%20and%20orange%20ball%20on%20clean%20white%20background%20studio%20lighting%20high%20quality%20sports%20equipment&width=400&height=400&seq=bb-eq-01&orientation=squarish"
                  alt="Basketball Equipment"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-bold text-lg">Basketball</h3>
                  <p className="text-white/80 text-sm">Shoes, Jerseys & Balls</p>
                </div>
              </div>
            </div>

            {/* Baseball */}
            <div className="relative group cursor-pointer">
              <div className="relative w-full h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20baseball%20wooden%20bat%20leather%20glove%20and%20white%20ball%20on%20clean%20white%20background%20studio%20lighting%20high%20quality%20sports%20equipment&width=400&height=400&seq=bs-eq-01&orientation=squarish"
                  alt="Baseball Equipment"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-bold text-lg">Baseball</h3>
                  <p className="text-white/80 text-sm">Bats, Gloves & Gear</p>
                </div>
              </div>
            </div>

            {/* Soccer */}
            <div className="relative group cursor-pointer">
              <div className="relative w-full h-48 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://readdy.ai/api/search-image?query=professional%20soccer%20cleats%20football%20boots%20and%20black%20white%20ball%20on%20clean%20white%20background%20studio%20lighting%20high%20quality%20sports%20equipment&width=400&height=400&seq=sc-eq-01&orientation=squarish"
                  alt="Soccer Equipment"
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="text-white font-bold text-lg">Soccer</h3>
                  <p className="text-white/80 text-sm">Cleats, Balls & Guards</p>
                </div>
              </div>
            </div>
          </div>

          {/* Stats Bar */}
          <div className="mt-12 flex flex-wrap justify-center items-center gap-8 text-white">
            <div className="text-center">
              <div className="text-3xl font-bold">45+</div>
              <div className="text-sm text-white/80">Premium Products</div>
            </div>
            <div className="w-px h-12 bg-white/30"></div>
            <div className="text-center">
              <div className="text-3xl font-bold">15+</div>
              <div className="text-sm text-white/80">Sports Supported</div>
            </div>
            <div className="w-px h-12 bg-white/30"></div>
            <div className="text-center">
              <div className="text-3xl font-bold">50+</div>
              <div className="text-sm text-white/80">Teams Trust Us</div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
